export default "__VITE_ASSET__ClrtIw6K__"